(function($) {
  function scrollNav() {
    if ($(document).scrollTop() > 20) {
      $('#nav').addClass('is-scrolled');
    } else {
      $('#nav').removeClass('is-scrolled');
    }
    if ($(document).scrollTop() > 20) {
      $('#menu').addClass('is-scrolled');
    } else {
      $('#menu').removeClass('is-scrolled');
    }
  }
  scrollNav();
  $(document).scroll(function() {
    scrollNav();
  });
  $(document).on('click', '#menu-open, #menu-open-topbar', function(event) {
    event.preventDefault();
    $('#menu').fadeIn('normal', function() {
      $('#menu').scrollTop(0);
    });
    $('body').css('overflow-y', 'hidden');
  });
  $(document).on('click', '#menu-close', function(event) {
    event.preventDefault();
    $('#menu').fadeOut('normal', function() {
    });
    $('body').css('overflow-y', 'scroll');
  });
  // Show and hide address form
  $(document).on('click', '.js-edit-address', function(event) {
    event.preventDefault();
    var id = '#' + $(this).data('target');
    $(id).slideDown(300);
  });
  $(document).on('click', '.js-close-edit-address', function(event) {
    event.preventDefault();
    var id = '#' + $(this).data('target');
    $(id).slideUp(300);
  });
  // Show and hide login form
  $(document).on('click', '.js-recover-form', function(event) {
    event.preventDefault();
    $('#login-form').slideUp(300);
    $('#recover-form').slideDown(300);
  });
  $(document).on('click', '.js-login-form', function(event) {
    event.preventDefault();
    $('#recover-form').slideUp(300);
    $('#login-form').slideDown(300);
  });
  // Update url on variant select
  $(document).on('change', '#product-select', function(event) {
    event.preventDefault();
    var newURL =
      window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this.value;
    window.location.assign(newURL);
  });
  $(document).on('click', '.c-button--size', function(event) {
    event.preventDefault();
    var newURL =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      $(this).attr('href');
    window.location.assign(newURL);
  });
})(jQuery);
